import {Component, Input} from "@angular/core";
import {MvsFilterComponentBase} from "./mvs-filter-component-base";
import {FilterAttributeGroup} from "../api/filter-attribute-group";

@Component({
    selector: 'mvs-filter-component-base-attribute',
    template: '',
    standalone: false
})
export class MvsFilterComponentBaseAttribute extends  MvsFilterComponentBase{

    @Input() filterAttributeGroups: FilterAttributeGroup[] | undefined;
    // @Input() joins: MetaDataJoinDto[] | undefined;
    @Input() enumValuesType: 'label' | 'technicalLabel' = 'label';

}
